import apiClient from "./axios"

// ✅ Get accessories company lists (with filters / pagination)
export const getAccessoriesCompanyList = async (params = {}) => {
  const { data } = await apiClient.get("/accessories-companies", { params })
  return data
}

// ✅ Get single accessories company by ID
export const getAccessoriesCompanyById = async id => {
  const { data } = await apiClient.get(`/accessories-companies/${id}`)
  return data
}

// ✅ Create accessories company
export const createAccessoriesCompany = async payload => {
  const { data } = await apiClient.post("/accessories-companies", payload)
  return data
}

// ✅ Update accessories company
export const updateAccessoriesCompany = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/accessories-companies/${id}`, payload)
  return data
}

// ✅ Soft delete (move to trash)
export const deleteAccessoriesCompany = async id => {
  const { data } = await apiClient.delete(`/accessories-companies/${id}`)
  return data
}

// ✅ Get trashed accessories companies
export const getTrashedAccessoriesCompanies = async (params = {}) => {
  const { data } = await apiClient.get("/accessories-companies/trashed", { params })
  return data
}

// ✅ Get accessories company by slug
export const getAccessoriesCompanyBySlug = async slug => {
  const { data } = await apiClient.get(`/accessories-companies/slug/${slug}`)
  return data
}

// ✅ Restore trashed accessories company
export const restoreAccessoriesCompany = async id => {
  const { data } = await apiClient.post(`/accessories-companies/${id}/restore`)
  return data
}

// ✅ Permanently delete accessories company
export const forceDeleteAccessoriesCompany = async id => {
  const { data } = await apiClient.delete(`/accessories-companies/${id}/force-delete`)
  return data
}
